module.exports = __webpack_public_path__ + "app/principal/principal-detail-3a1-niM-.html";